import { gql } from '@apollo/client';
import Loading from 'components/Loading';
import { useQuery } from 'hooks/apollo';
import React from 'react';
import { useRouteMatch, useHistory, generatePath } from 'react-router-dom';

import LegacyEditSurvey from 'containers/Surveys/EditSurvey';
import TranslateSurvey from 'containers/Surveys/EditSurvey/TranslateSurvey';
import EditDistribution from 'containers/Surveys/EditSurvey/EditDistribution';
import EditSurveyVersion from './EditSurveySteps/EditSurvey';

const QUERY = gql`
  query EditSurvey($id: ID!) {
    surveyGroup(id: $id) {
      id
      surveys {
        id
        primary
        version
      }
    }
  }
`;

const EditSurvey = () => {
  const { path, params } = useRouteMatch('/data-sources/:dataSourceId/:module/edit/:surveyGroupId/:surveyId?/:step?/:distributionId?/:distributionStep?');
  const history = useHistory();
  const { loading, data } = useQuery(QUERY, {
    variables: { id: params.surveyGroupId },
  });

  if (loading) {
    return <Loading />;
  }

  const { surveyGroup } = data;
  let survey = surveyGroup?.surveys.find(s => s.id === params.surveyId);

  if (survey?.version && !survey.primary) {
    survey = surveyGroup.surveys.find(s => s.version === survey.version && s.primary);
  }

  if (!survey) {
    return null;
  }

  const goTo = (p) => {
    history.push(generatePath(path, { ...params, ...p }));
  };

  if (survey.version) {
    return <EditSurveyVersion surveyId={survey.id} onSurveySelect={surveyId => goTo({ surveyId })} />;
  }

  if (params.step === 'translate') {
    return <TranslateSurvey surveyId={params.surveyId} />;
  }

  if (params.step === 'distribution') {
    return <EditDistribution distributionId={params.distributionId} step={params.distributionStep} goTo={goTo} />;
  }

  return <LegacyEditSurvey surveyId={params.surveyId} step={params.step} goTo={goTo} />;
};

export default EditSurvey;
